import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

export const availableLanguages = ["nl"];

let preferredLang = localStorage.getItem(`${process.env.VUE_APP_NAME}_LANG`) || "nl";

preferredLang = preferredLang.substring(0, 2);
if (!availableLanguages.includes(preferredLang)) {
    preferredLang = "nl";
}

const messages = {};
messages[preferredLang] = getMessages(preferredLang);
export const i18n = new VueI18n({
    locale: preferredLang,
    fallbackLocale: preferredLang,
    messages
});
const loadedLanguages = [];

function setI18nLanguage(lang) {
    i18n.locale = lang;
    const el = document.querySelector("html");
    if (el) {
        el.setAttribute("lang", lang);
    }
    localStorage.setItem(`${process.env.VUE_APP_NAME}_LANG`, lang);
    return lang;
}

function getMessages(lang) {
    let requireModule = null;
    if (lang === "nl") {
        requireModule = require.context("@/localization/nl/.", false, /\.json$/);
    }

    const localMessages = [];
    localMessages[lang] = {};
    if (requireModule) {
        requireModule.keys().forEach(fileName => {
            const key = fileName.replace(/(\.\/|\.json)/g, "");
            localMessages[lang][key] = requireModule(fileName);
        });
    }

    return {
        ...require(`@/localization/${lang}.json`),
        ...localMessages[lang]
    };
}

export function loadLanguageAsync(lang) {
    if (i18n.locale === lang) {
        return Promise.resolve(setI18nLanguage(lang));
    }

    if (loadedLanguages.includes(lang)) {
        return Promise.resolve(setI18nLanguage(lang));
    }

    i18n.setLocaleMessage(lang, getMessages(lang));
    loadedLanguages.push(lang);
    return Promise.resolve(setI18nLanguage(lang));
}
